import { IGetAllProjetoArquivoUseCase } from "../../../presentation/useCases/read/get_all_projeto_arquivo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { GetAllProjetoArquivoRequestModel, ProjetoArquivoListModel } from "../../models/projeto_arquivo_model";
import { DocumentoLista } from "../../models/documentos_lista";


export class GetAllProjetoArquivoUseCase extends BasePaginatedUseCase<DocumentoLista> implements IGetAllProjetoArquivoUseCase {
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async  getAllProjetoArquivo(IdProjeto: number, page: number, rowsPerPage: number): Promise<void> {
    const response = await this.repository.getAllProjetoArquivo(IdProjeto, page, rowsPerPage);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
